"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "rewards_cont" };
const _hoisted_2 = { key: 0 };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_planetary_track_reward = (0, vue_1.resolveComponent)("planetary-track-reward");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (_ctx.mostTags)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_2, "! "))
            : (0, vue_1.createCommentVNode)("", true),
        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.myReward, (reward, idx) => {
            return ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_planetary_track_reward, {
                reward: reward,
                key: idx,
                gameOptions: _ctx.gameOptions
            }, null, 8, ["reward", "gameOptions"]));
        }), 128))
    ]));
}
